// Generated by scripts/generate-env-secrets.js. Do not edit or commit.
export const ENV_SECRETS = {
  RPC_URL: "https://bnb-testnet.g.alchemy.com/v2/Ehx84XSejJSJRNvl0EqCMokHaTmEEKlP",
  CHATBOT_KEY: "p00pKsKFEbZzjkbkX3JYV",
  WALLET_CONNECT_PROJECT_ID: "1022f8e674ac7cca903dd5d2df11cf54",
  LOCAL_STORAGE_SECRET: "D96Q2M84E3400063E8366912AQ45488H",
};
